/**
 * Global Error Handlers for Institutional Website
 * 
 * Auto-reloads on chunk errors after deploys to prevent stale bundle issues.
 */

// Contador para prevenir loops infinitos
let errorTimestamps = [];
const MAX_ERRORS = 3;
const TIME_WINDOW = 10000;

const isInErrorLoop = () => {
    const now = Date.now();
    errorTimestamps = errorTimestamps.filter(ts => now - ts < TIME_WINDOW);
    errorTimestamps.push(now);
    return errorTimestamps.length >= MAX_ERRORS;
};

/**
 * Handler para Promises rejeitadas (chunk errors)
 */
const handleUnhandledRejection = (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);

    console.error('Unhandled rejection:', message);

    if (isInErrorLoop()) {
        console.error('💥 Error loop detected, stopping reloads.');
        return;
    }

    // Check for chunk load errors (happens after deploy)
    const isChunkError =
        message.includes('ChunkLoadError') ||
        message.includes('Loading chunk') ||
        message.includes('Failed to fetch dynamically imported module') ||
        message.includes("Unexpected token '<'") ||
        (reason instanceof TypeError && message.includes('Failed to fetch'));

    if (isChunkError) {
        const lastReload = sessionStorage.getItem('lastChunkReload');
        const now = Date.now();

        if (!lastReload || (now - parseInt(lastReload)) > 10000) {
            console.warn('🔄 Detected stale chunks after deploy, reloading...');
            sessionStorage.setItem('lastChunkReload', now.toString());

            // Clear cache
            if ('caches' in window) {
                caches.keys().then(names => names.forEach(name => caches.delete(name)));
            }

            window.location.reload();
            return;
        }
    }

    event.preventDefault();
};

/**
 * Handler para erros JavaScript
 */
const handleJavaScriptError = (event) => {
    const { message } = event;

    if (isInErrorLoop()) {
        console.error('💥 Error loop detected.');
        return true;
    }

    // Check for chunk errors via script errors
    const isChunkError =
        message.includes('Loading chunk') ||
        message.includes("Unexpected token '<'");

    if (isChunkError) {
        const lastReload = sessionStorage.getItem('lastChunkReload');
        const now = Date.now();

        if (!lastReload || (now - parseInt(lastReload)) > 10000) {
            console.warn('🔄 Script error detected, reloading...');
            sessionStorage.setItem('lastChunkReload', now.toString());
            window.location.reload();
        }
    }

    return true;
};

export const initGlobalErrorHandlers = () => {
    window.onerror = handleJavaScriptError;
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    console.log('✅ Global error handlers initialized');
};

export default { initGlobalErrorHandlers };
